import React from 'react';

import { ListHelmet } from 'components';
import matchList from 'modules/match-list';
import { favoriteHomeTabs } from '../constants';

import './favoriteList.scss';

const {
    components: { FavoriteList },
} = matchList;

const FavoriteListView: React.FC = () => (
    <div styleName="container">
        <ListHelmet />
        <FavoriteList homeTabs={favoriteHomeTabs} />
    </div>
);

export default React.memo(FavoriteListView);
